export default {
  backendBaseUrl: process.env.REACT_APP_BACKEND_BASE_URL,
};
